export const COUNTRIES = {
  "india": {
    "name": "India",
    "code": "IN",
    "flag": "🇮🇳",
    "currency": "INR",
    "phone_prefix": "+91",
    "cities": ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Chennai", "Kolkata", "Pune", "Ahmedabad", "Jaipur", "Lucknow", "Bhopal", "Indore", "Chandigarh", "Nagpur", "Patna", "Surat", "Kochi", "Guwahati", "Varanasi", "Coimbatore"]
  },
  "usa": {
    "name": "United States",
    "code": "US",
    "flag": "🇺🇸",
    "currency": "USD",
    "phone_prefix": "+1",
    "cities": ["New York", "Los Angeles", "Chicago", "Houston", "Phoenix", "Philadelphia", "San Antonio", "San Diego", "Dallas", "San Francisco", "Seattle", "Miami", "Denver", "Boston", "Atlanta", "Las Vegas", "Portland", "Austin", "Nashville", "Detroit"]
  },
  "uk": {
    "name": "United Kingdom",
    "code": "GB",
    "flag": "🇬🇧",
    "currency": "GBP",
    "phone_prefix": "+44",
    "cities": ["London", "Manchester", "Birmingham", "Leeds", "Glasgow", "Liverpool", "Edinburgh", "Bristol", "Cardiff", "Belfast", "Sheffield", "Nottingham", "Leicester", "Brighton", "Oxford", "Cambridge", "York", "Bath", "Aberdeen", "Dundee"]
  },
  "canada": {
    "name": "Canada",
    "code": "CA",
    "flag": "🇨🇦",
    "currency": "CAD",
    "phone_prefix": "+1",
    "cities": ["Toronto", "Vancouver", "Montreal", "Calgary", "Ottawa", "Edmonton", "Winnipeg", "Quebec City", "Hamilton", "Victoria", "Halifax", "Regina", "Saskatoon", "St. John's", "Kelowna", "Kingston", "Thunder Bay", "Fredericton", "Charlottetown", "Whitehorse"]
  },
  "australia": {
    "name": "Australia",
    "code": "AU",
    "flag": "🇦🇺",
    "currency": "AUD",
    "phone_prefix": "+61",
    "cities": ["Sydney", "Melbourne", "Brisbane", "Perth", "Adelaide", "Gold Coast", "Canberra", "Hobart", "Darwin", "Newcastle", "Cairns", "Townsville", "Wollongong", "Geelong", "Ballarat", "Bendigo", "Toowoomba", "Launceston", "Mackay", "Rockhampton"]
  },
  "uae": {
    "name": "UAE",
    "code": "AE",
    "flag": "🇦🇪",
    "currency": "AED",
    "phone_prefix": "+971",
    "cities": ["Dubai", "Abu Dhabi", "Sharjah", "Ajman", "Ras Al Khaimah", "Fujairah", "Umm Al Quwain", "Al Ain", "Khor Fakkan", "Dibba Al-Fujairah"]
  },
  "saudi_arabia": {
    "name": "Saudi Arabia",
    "code": "SA",
    "flag": "🇸🇦",
    "currency": "SAR",
    "phone_prefix": "+966",
    "cities": ["Riyadh", "Jeddah", "Mecca", "Medina", "Dammam", "Khobar", "Dhahran", "Tabuk", "Abha", "Taif", "Hail", "Jubail", "Yanbu", "Buraidah", "Najran"]
  },
  "germany": {
    "name": "Germany",
    "code": "DE",
    "flag": "🇩🇪",
    "currency": "EUR",
    "phone_prefix": "+49",
    "cities": ["Berlin", "Munich", "Hamburg", "Frankfurt", "Cologne", "Stuttgart", "Dusseldorf", "Leipzig", "Dortmund", "Essen", "Bremen", "Dresden", "Hanover", "Nuremberg", "Bonn", "Mannheim", "Augsburg", "Wiesbaden", "Heidelberg", "Freiburg"]
  },
  "france": {
    "name": "France",
    "code": "FR",
    "flag": "🇫🇷",
    "currency": "EUR",
    "phone_prefix": "+33",
    "cities": ["Paris", "Marseille", "Lyon", "Toulouse", "Nice", "Nantes", "Strasbourg", "Montpellier", "Bordeaux", "Lille", "Rennes", "Reims", "Toulon", "Saint-Etienne", "Le Havre", "Grenoble", "Dijon", "Angers", "Nimes", "Tours"]
  },
  "singapore": {
    "name": "Singapore",
    "code": "SG",
    "flag": "🇸🇬",
    "currency": "SGD",
    "phone_prefix": "+65",
    "cities": ["Singapore - Orchard", "Singapore - Marina Bay", "Singapore - Jurong", "Singapore - Tampines", "Singapore - Woodlands", "Singapore - Clementi", "Singapore - Bedok", "Singapore - Toa Payoh", "Singapore - Ang Mo Kio", "Singapore - Bishan", "Singapore - Bukit Timah", "Singapore - Sentosa", "Singapore - Changi", "Singapore - Punggol", "Singapore - Sengkang"]
  }
};
